const normalizeDateString = (value) => {
    if (!value) return null;

    if (value instanceof Date) return value;

    if (typeof value === 'object' && typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (typeof value === 'string') {
        const match = value.match(
            /^(\d{2})[./](\d{2})[./](\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/
        );

        if (match) {
            const [, dd, mm, yyyy, hh, min, ss] = match;

            return new Date(
                Number(yyyy),
                Number(mm) - 1,
                Number(dd),
                Number(hh),
                Number(min),
                Number(ss)
            );
        }

        return new Date(value);
    }

    return null;
};
export default normalizeDateString;
